import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Button from '../../buttons/Button';//eslint-disable-line import/no-named-as-default
import Resources from '../resourceLinks/ResourceLinks';
import Image from '../../objects/image/SecondaryImage';
import LibraryImage from '../../objects/image/SecondaryLibraryImage';
import * as appDataActions from '../../../actions/appDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appConstants from "../../../constants/appConstants";
import * as appHelper from '../../../helpers/appHelper';
import * as userDataHelper from '../../../helpers/userDataHelper';
import * as objectConstants from '../../../constants/objectConstants';
import * as assetConstants from '../../../constants/assetConstants';
import {TweenLite, Elastic, Bounce, Expo} from 'gsap';
import gsap from 'gsap-react-plugin';

class ProducerNotes extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            producer_notes_label: appHelper.getLocaleString("producer_notes_label")
        };
        this.getImagePath = this.getImagePath.bind(this);
        this.show = this.show.bind(this);
    }

    componentDidMount() {
        this.show();
    }

    componentWillReceiveProps(nextProps) {
        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                screen_not_ready_label: appHelper.getLocaleString("producer_notes_label")
            });
        }
    }

    componentDidUpdate() {

    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    show() {
        let optionRef = this.refs[`${this.props.screen_id}_text`];
        TweenLite.set(optionRef, {height: "auto"});
        TweenLite.from(optionRef, objectConstants.SHOW_PANEL_DURATION, {
            height: 0,
            ease: Expo.easeInOut
        });
    }

    render() {
        return (
            <div className={`object-container`} ref={`${this.props.screen_id}_text`}>
                <div className="producer-notes">
                    <img className="guroo-producer-logo" src={require(`../../../assets/images/logos/guroo_producer_logo.png`)} alt=""/>
                    <h4 className="producer-notes-title">{this.state.producer_notes_label}</h4>
                    {this.props.notes.map(note =>
                        <div className="producer-notes-description" key={note.screen_id} dangerouslySetInnerHTML={{__html: note.notes}} />
                    )}
                </div>
            </div>
        );
    }
}

ProducerNotes.propTypes = {
    notes: PropTypes.array.isRequired,
    screen_id: PropTypes.number.isRequired,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired
};

ProducerNotes.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ProducerNotes);



/** WEBPACK FOOTER **
 ** ./src/components/objects/producerNotes/ProducerNotes.js
 **/